import type { Product } from "@encoway/c-services-js-client"
import {
    Characteristics,
    Filter,
    Selection
} from "@encoway/c-services-js-client"

import { getCatalogService } from "../../app/catalogServiceHolder"
import {
    CABLE_LENGTH_CHARACTERISTIC,
    CABLE_TYPE
} from "../../constants/cableConstants"
import { getCharacteristicValue } from "../../utils/characteristicValueService"

const characteristicsFilter = new Characteristics()
    .id("product_image")
    .id("manufacturer")
    .id("cabletype")
    .id("cable_length")
    .id("colour_connectors")
    .id("connection_side_1")
    .id("connection_side_2")
    .id("series_to_connect")
    .id("x_pole")

const PRODUCT_GROUPS = ["MIDI_CABLES", "cable", "DALI_CABLES"]

function createSelectionQuery(groupId: string) {
    const productGroupFilter = Filter.productGroupFilter()
        .id(groupId)
        .includeSubgroups(false)
    return new Selection()
        .limit(1000)
        .filter(productGroupFilter)
        .characteristics(characteristicsFilter)
}

function prepareCable(cableProducts: Map<string, Map<string, Product>>) {
    return function (product: Product) {
        const cableLength = Number.parseFloat(
            getCharacteristicValue(product, CABLE_LENGTH_CHARACTERISTIC)
        )
        const cableColor = getCharacteristicValue(product, CABLE_TYPE)
        if (cableLength && cableColor) {
            if (!cableProducts.has(cableColor)) {
                cableProducts.set(cableColor, new Map<string, Product>())
            }
            cableProducts.get(cableColor)?.set(product.id, product)
        }
    }
}

export const determineCableProducts = async () => {
    const catalogService = getCatalogService()

    const products = await PRODUCT_GROUPS.reduce(
        async (accProducts, product) => {
            try {
                const result = await catalogService.products(
                    createSelectionQuery(product)
                )
                return [...(await accProducts), ...result.products]
            } catch (error) {
                console.error(`Error fetching products for group ${product}:`)
            }

            return await accProducts
        },
        Promise.resolve([]) as Promise<Product[]>
    )

    const cableProducts = new Map<string, Map<string, Product>>()

    products.forEach(prepareCable(cableProducts))
    return cableProducts
}
